import React from "react";
import { HXIcon } from "@aph/ui-lib-humanx";
import { BannerWithCard } from "@/components/PagePiller/api/interface";
import Image from "@/components/Image";
import { DeviceInfo } from "@/interface/deviceInfo";
import { RegisterRefType } from "@/components/PageHome/interfaces";
import styles from "./BannerWithImage.module.scss";

interface BannerWithImageProps {
  data: BannerWithCard;
  userAgent: DeviceInfo;
  registerRef?: RegisterRefType;
}

const BannerWithImage: React.FC<BannerWithImageProps> = ({ data, userAgent, registerRef }) => {
  const {
    Image: image,
    Title: title,
    Description: description,
    TitleTextVariant: textVariant,
    CardColor: cardColor,
  } = data;

  return (
    <section
      data-ref_id={data?.refId}
      ref={(el) => {
        if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
      }}
      className={`${userAgent?.isDesktop ? "container" : ""} scrollMargin spacingBetweenSections`}
    >
      <div className={styles.container}>
        <Image
          className={styles.backgroundImage}
          src={image?.data?.attributes?.url}
          alt={image?.data?.attributes?.alternativeText || title}
          eagerLoad={true}
        />
        <div className={styles.backdrop} />
        <div className={!userAgent?.isDesktop ? "container" : ""}>
          {title && (
            <div className={`${styles[textVariant]} ${styles.title}`} dangerouslySetInnerHTML={{ __html: title }} />
          )}
          <div className={styles.card} style={{ backgroundColor: cardColor }}>
            {description && (
              <div className={styles.content}>
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </div>
            )}
            <div className={styles.logoBg}>
              <HXIcon className={styles.item} backgroundColor="#C8D2FD" iconPosition="topLeft" size="50x50" />
              <HXIcon className={styles.item} backgroundColor="#C8D2FD" iconPosition="topRight" size="50x50" />
              <div className={styles.smallOne}>
                <HXIcon className={styles.item} backgroundColor="#C8D2FD" iconPosition="bottomLeft" size="75x75" />
              </div>
              <HXIcon className={styles.item} backgroundColor="#C8D2FD" iconPosition="bottomRight" size="50x50" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerWithImage;
